import type { ReactNode } from 'react'
import { Header } from './Header'
import { Sidebar } from './Sidebar'

interface AppShellProps {
  children: ReactNode
  onSearchOpen?: () => void
  onCreateRoom?: () => void
  onNewDirectMessage?: () => void
  onKeyRestore?: () => void
  onSecurity?: () => void
  onCodexAuth?: () => void
}

export function AppShell({ children, onSearchOpen, onCreateRoom, onNewDirectMessage, onKeyRestore, onSecurity, onCodexAuth }: AppShellProps) {
  return (
    <div className="mode-slack align-left h-screen flex flex-col bg-[rgb(var(--np-base))]">
      <Header onSearchOpen={onSearchOpen} onKeyRestore={onKeyRestore} onSecurity={onSecurity} onCodexAuth={onCodexAuth} />
      <div className="flex flex-1 min-h-0">
        <Sidebar onCreateRoom={onCreateRoom} onNewDirectMessage={onNewDirectMessage} />
        <main className="flex-1 flex flex-col min-w-0 min-h-0">
          {children}
        </main>
      </div>
    </div>
  )
}
